import type { TagName } from '@/types'

export default function useTagsStorage(key: string) {
  function get(): Set<TagName> {
    const value = localStorage.getItem(key) ?? undefined
    if (value === undefined) return new Set()
    return new Set(value.split(','))
  }

  function set(tags: Set<TagName>): void {
    localStorage.set(key, Array.from(tags).join(','))
  }

  return { get, set }
}
